module.exports = __webpack_public_path__ + "img/rating-star.84a69e60.svg";